import script from "./AccountDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountDropdown.vue?vue&type=script&setup=true&lang=js"

import "./AccountDropdown.vue?vue&type=style&index=0&id=140ed787&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-140ed787"]])

export default __exports__